export const defaultDockerfileName = 'agentbox.Dockerfile'
export const fallbackDockerfileName = 'Dockerfile'
